import React, { useMemo } from 'react';
import { pickSimilarListings } from '../lib/similarMatching';
import PropertyCard from './PropertyCard';
import './SimilarListings.css';

export default function SimilarListings({ listing, allListings }) {
  const similar = useMemo(() => {
    if (!listing) return [];
    const profile = {
      city:     listing.city,
      type:     listing.type,
      price:    listing.price,
      bedrooms: listing.bedrooms,
    };
    return pickSimilarListings(profile, allListings || [], {
      excludeIds: [listing.id],
    });
  }, [listing, allListings]);

  if (!similar.length) return null;

  return (
    <div className="sim-listings">
      <div className="sim-listings__header">
        <h3 className="sim-listings__title">Similar Properties</h3>
        <span className="sim-listings__count">{similar.length} found</span>
      </div>
      <div className="sim-listings__grid">
        {similar.map((l, i) => (
          <PropertyCard key={l.id} listing={l} index={i} />
        ))}
      </div>
    </div>
  );
}
